import { render, staticRenderFns } from "./CiteThisIcon.vue?vue&type=template&id=1144e125&scoped=true&"
import script from "./CiteThisIcon.vue?vue&type=script&lang=js&"
export * from "./CiteThisIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144e125",
  null
  
)

export default component.exports